import $ from 'jquery';
var OrderAction;
(function (OrderAction) {
    OrderAction["Up"] = "up";
    OrderAction["Down"] = "down";
})(OrderAction || (OrderAction = {}));
const ELEMENT_SELECTOR = '.js__collection-items-order-button';
const ELEMENT_WRAPPER_SELECTOR = '.js__collection-items-order-wrapper';
export class CollectionItemsOrder {
    static init($root = $('body')) {
        this.initActions($root);
    }
    static initActions($root) {
        const $button = $(ELEMENT_SELECTOR);
        $root.on('click', ELEMENT_SELECTOR, e => {
            const $element = $(e.currentTarget);
            const $wrappers = $root.find(ELEMENT_WRAPPER_SELECTOR);
            const $wrapper = $element.closest(ELEMENT_WRAPPER_SELECTOR);
            const wrapperIndex = $wrapper.index();
            const action = $element.data('action');
            if (action === OrderAction.Up) {
                if (wrapperIndex == 0) {
                    return;
                }
                this.swapWrapperInputValues($wrapper, $($wrappers.get(wrapperIndex - 1)));
            }
            else {
                if (wrapperIndex == $wrappers.length - 1) {
                    return;
                }
                this.swapWrapperInputValues($wrapper, $($wrappers.get(wrapperIndex + 1)));
            }
        });
    }
    static swapWrapperInputValues($wrapper1, $wrapper2) {
        const $input1 = $wrapper1.find('input');
        const value1 = $input1.val() || '';
        const $input2 = $wrapper2.find('input');
        const value2 = $input2.val() || '';
        $input1.val(value2);
        $input2.val(value1);
    }
}
